import "./Display.css"


const Banner = () => {
  
  return (
    <div className="banner"  style={{backgroundImage: "url('ACDS_Logo_1080p_White.png')"}} >
      </div>

  );
};

export default Banner;
